import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-zubereitung',
  templateUrl: './zubereitung.component.html',
  styleUrls: ['./zubereitung.component.css']
})
export class ZubereitungComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
